import React, { useState, useEffect } from 'react'

const PagesHeader = ({ header, body }) => (
  <div className="mb-4 text-center">
    <div className="jumbotron-content text-center pb-0">
      <h1 className="black text-sm-center mb-3">
        {header}
      </h1>
    </div>
    <div>
      {body}
    </div>
  </div>
)

export default PagesHeader
